import type { Role } from '@kindred/types';

/**
 * Single source of truth for the sidebar nav — lists ALL modules + the /admin
 * area. `minRoles` is UX gating only (server enforces §4.1); `platformAdmin`
 * marks the Module 12 area shown only to kindredAdmin.
 */
export interface NavItemConfig {
  label: string;
  path: string;
  /** If set, item is only shown when the active role is one of these. */
  minRoles?: Role[];
  /** Platform-admin only (Module 12). */
  platformAdmin?: boolean;
}

export interface NavSectionConfig {
  title: string;
  items: NavItemConfig[];
}

export const navSections: NavSectionConfig[] = [
  {
    title: 'Overview',
    items: [
      { label: 'Dashboard', path: '/analytics' },
      { label: 'Onboarding', path: '/onboarding' },
    ],
  },
  {
    title: 'Manage',
    items: [
      { label: 'Offers', path: '/offers', minRoles: ['owner', 'admin', 'editor'] },
      { label: 'Catalogue', path: '/catalogue', minRoles: ['owner', 'admin', 'editor'] },
      {
        label: 'Merchant Map',
        path: '/merchant-map',
        minRoles: ['owner', 'admin', 'editor'],
      },
      {
        label: 'Distribution',
        path: '/distribution',
        minRoles: ['owner', 'admin', 'editor'],
      },
      { label: 'Tracking', path: '/tracking', minRoles: ['owner', 'admin', 'editor'] },
    ],
  },
  {
    title: 'Account',
    items: [
      { label: 'Billing', path: '/billing', minRoles: ['owner', 'admin', 'finance'] },
      {
        label: 'Conversions',
        path: '/billing/conversions',
        minRoles: ['owner', 'admin', 'finance'],
      },
      { label: 'Legal', path: '/legal' },
      { label: 'Settings', path: '/settings' },
    ],
  },
  {
    title: 'Kindred Admin',
    items: [
      { label: 'Merchants', path: '/admin', platformAdmin: true },
      { label: 'Surfaces', path: '/admin/surfaces', platformAdmin: true },
    ],
  },
];
